import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { AppEntities } from "src/config/entities";
import { AssemblyDisassemblyOfGoodsDto } from "../dtos/AssemblyDisassemblyOfGoodsDto";
import { AssemblyDisassemblyOfGoodsModel } from "../models/AssemblyDisassemblyOfGoodsModel";
import { AssemblyDisassemblyOfGoodsProductMaterialDto } from "../dtos/AssemblyDisassemblyOfGoodsProductMaterialDto";
import { AssemblyDisassemblyOfGoodsService } from "src/services/documents/AssemblyDisassemblyOfGoodsService";

interface IProps {
  documentId?: string;
}

export const useFetchAssemblyDisassemblyOfGoods = ({ documentId }: IProps) => {
  const [isDocumentLoading, setIsDocumentLoading] = useState(false);
  const [documentDto, setDocumentDto] = useState<AssemblyDisassemblyOfGoodsDto | null>(null);
  const [documentModel, setDocumentModel] = useState<AssemblyDisassemblyOfGoodsModel | null>(null);
  const dataService = AppEntities.AssemblyDisassemblyOfGoods.getDataService() as AssemblyDisassemblyOfGoodsService;

  const postDocument = async () => {
    if (!documentId) return;
    await dataService.PostDocument(documentId);
    toast.success("Document posted successfully");
  };

  const cancelDocument = async () => {
    if (!documentId) return;
    await dataService.CancelDocument(documentId);
    toast.success("Document canceled successfully");
  };

  const updateDocument = async (documentModel: AssemblyDisassemblyOfGoodsModel) => {
    if (!documentId) return;
    const requestDto: AssemblyDisassemblyOfGoodsDto = { ...documentModel };
    const responseDto = await dataService.Update(requestDto);
    setDocumentDto(responseDto);
  };

  const fetchDocument = async () => {
    try {
      setIsDocumentLoading(true);

      console.log("documentId", documentId);

      let responseDto: AssemblyDisassemblyOfGoodsDto | null = null;
      let responseProductsMaterials: AssemblyDisassemblyOfGoodsProductMaterialDto[] = [];

      if (!documentId) {
        responseDto = await dataService.Create({
          documentDate: new Date()
        });
        setDocumentDto(responseDto);
      } else {
        responseDto = await dataService.Get(documentId);
        setDocumentDto(responseDto);
      }

      if (!responseDto) return;

      const newModel: AssemblyDisassemblyOfGoodsModel = {
        ...responseDto,
        productsMaterials: [...responseProductsMaterials]
      };
      setDocumentModel(newModel);
    } catch (e) {
      console.log(e);
    } finally {
      setIsDocumentLoading(false);
    }
  };

  useEffect(() => {
    fetchDocument();
  }, [documentId]);

  return {
    isDocumentLoading,
    documentDto,
    documentModel,
    postDocument,
    cancelDocument,
    updateDocument
  };
};
